import _ from 'lodash';
import { i18n } from './i18n';
import { request } from 'beans-admin-plugin';
import pluralize from 'pluralize';

const associationRemotePreload = ({ v }) => {
  const requestUrl = `/${pluralize(_.map(v.extra.model_name.split('::'), str => _.snakeCase(str)).join('/'))}/read_options`
  let query = { per_page: 100 }

  if (v.extra.model_name === 'User') {
    query.is_block_eq = false
  }

  return async () =>  {
    const { data } = await request.get(requestUrl, query);
    return data.map(item => ({ value: item.id, label: getLabel({ item, v }) }));
  }
}

const associationRemoteSearch = ({ v }) => {
  const requestUrl = `/${pluralize(_.map(v.extra.model_name.split('::'), str => _.snakeCase(str)).join('/'))}/read_options`
  let query = { per_page: 999 }

  if (v.extra.model_name === 'User') {
    query.is_block_eq = false
  }

  return async (keyword) => {
    const { data } = await request.get(requestUrl, { ...query, keyword });
    return data.map(item => ({ value: item.id, label: getLabel({ item, v }) }));
  }
}

export const getLabel = ({ item, v }) => {
  if (v.extra.model_name === 'User') {
    let name = item.profile.name

    if (item.is_block) {
      name = `${name}（已冻结）`
    }

    return name
  } else if ((v.extra.model_name === 'Product')) {
    return item.style_number
  } else {
    return item[v.extra.display_column]
  }
}

const components = {
  id: function() {
    return {
      renderCell: {
        component: 'input',
        props: {
          disabled: true
        }
      }
    }
  },
  type: function({ v }) {
    return {
      renderCell: {
        component: 'select',
        props: {
          options: _.map(v.extra.options, (value) => ({ label: i18n.t(`${_.map(v.model_name.split('::'), str => _.camelCase(str)).join('/')}.types.${value}`), value: value }))
        }
      }
    }
  },
  attached: function({ v }) {
    let props = {}

    if (v.extra) {
      if (v.extra.accept) {
        props.accept = v.extra.accept
      }
      if (v.extra.type) {
        props.type = v.extra.type
      }
      if (v.extra.limit) {
        props.limit = v.extra.limit
      }
      if (v.extra.size) {
        props.size = v.extra.size
      }
    }

    return {
      renderCell: {
        component: 'upload',
        props: props
      }
    }
  },
  belongsTo: function({ v, data }) {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          options: (data[v.extra.foreign_key] && data[v.extra.association_name]) ? [{ label: data[v.extra.association_name][v.extra.display_column], value: data[v.extra.foreign_key] }] : [],
          xRemotePreload: associationRemotePreload({ v }),
          xRemoteSearch: associationRemoteSearch({ v })
        },
        domProps: {
          style: 'width: 100%'
        }
      }
    }
  },
  hasMany: function({ v, data }) {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          multiple: true,
          options: _.map(data[v.extra.association_name], (value) => ({ label: value[v.extra.display_column], value: value.id })),
          xRemotePreload: associationRemotePreload({ v }),
          xRemoteSearch: associationRemoteSearch({ v })
        },
        domProps: {
          style: 'width: 100%'
        }
      }
    }
  },
  enum: function({ k, v }) {
    return {
      renderCell: {
        component: 'select',
        props: {
          options: _.map(v.extra.options, (value) => ({ label: i18n.t(`${_.map(v.model_name.split('::'), str => _.camelCase(str)).join('/')}.${_.camelCase(pluralize(k))}.${value}`), value: value }))
        }
      }
    }
  },
  string: function() {
    return {
      renderCell: {
        component: 'input'
      }
    }
  },
  integer: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  decimal: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  float: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  text: function () {
    return {
      renderCell: {
        component: 'textarea',
      }
    }
  },
  boolean: function () {
    return {
      renderCell: {
        component: 'switch',
      }
    }
  },
  date: function () {
    return {
      renderCell: {
        component: 'datePicker',
        props: {
          valueFormat: 'yyyy-MM-dd'
        }
      }
    }
  },
  time: function () {
    return {
      renderCell: {
        component: 'timePicker',
      }
    }
  },
  datetime: function () {
    return {
      renderCell: {
        component: 'dateTimePicker',
      }
    }
  },
  tag: function() {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          multiple: true,
          allowCreate: true,
          xRemotePreload: async () => {
            const { data } = await request.get('/acts_as_taggable_on/tags/read_options', { per_page: 100 })
            return _.map(data, ({ name }) => ({ value: name, label: name }))
          },
          xRemoteSearch: async (keyword) => {
            const { data } = await request.get('/acts_as_taggable_on/tags/read_options', { keyword })
            return _.map(data, ({ name }) => ({ value: name, label: name }))
          }
        },
        domProps: {
          style: 'width: 100%'
        }
      }
    }
  },
}

export default function(columns, data) {
  let hash = {}

  _.forEach(columns, (v, k) => {
    if (v.column_type && components[_.camelCase(v.column_type)]) {
      hash[k] = _.merge({
        prop: v.prop || k,
        label: i18n.t(v.label_key_path),
      }, components[_.camelCase(v.column_type)]({ k, v, data }))
    } else {
      console.error(`未生成：${k}`)
    }
  })

  return hash
}
